import { useContext, useEffect, useMemo, useState } from 'react';
import { useWindowDimensions } from '../../../../../../common/utils/windowDimensions';
import { Img, svgSprite } from '../../../../../../hybrid/wrappers';
import RegionAndCurrencySwitcher from '../../../../../../widgets/regionAndCurrencySwitcher/RegionAndCurrencySwitcher/RegionAndCurrencySwitcher';
import css from './HeaderButtons.module.scss';
import UserContext, { StoreContext, UserProfileContext } from '../../../../../../common/utils/getContext';
import classNames from 'classnames';
import Skeleton from '../../../../../../widgets/plug/Skeleton/Skeleton';
import { navigateV2 } from '../../../../../../common/utils/router';
import T from '../../../../../../common/components/T';
import Cartbuttons from '../../../../../store/components/CartButtons/CartButtons';
import StoreSearch from '../../../../../store/components/StoreSearch/StoreSearch';
import { useRouter } from 'next/router';
import NewsSearch from './components/NewsSearch/NewsSearch';

export default function HeaderButtons({ logout, isStorePage, isInputOpened, setIsInputOpened }) {
    const { setState } = useContext(UserContext);
    const { profileData, loaded } = useContext(UserProfileContext);
    const { cart, setCart } = useContext(StoreContext) || {};
    const windowDimensions = useWindowDimensions();
    const [showMenuUser, setShowMenuUser] = useState(false);
    const [openCart, setOpenCart] = useState(false);
    const [hasDataZooming, setHasDataZooming] = useState(false);

    useEffect(() => {
        // Проверяем наличие атрибута data-zooming у html
        const element = document.querySelector('html');
        if (element && element.hasAttribute('data-zooming')) {
            setHasDataZooming(true);
        } else {
            setHasDataZooming(false);
        }
    }, []);
    const HeaderProfile = () => {
        return profileData ? (
            <>
                <div style={{ position: 'relative' }}>
                    <div
                        className={classNames(css.headBtn)}
                        onClick={() => {
                            setShowMenuUser((pre) => !pre);
                        }}
                    >
                        <div className={css.singleImage}>
                            {!profileData?.image?.links?.preview ? (
                                svgSprite('user-gt', {
                                    width: '100%',
                                    height: '100%'
                                })
                            ) : (
                                <Img className={css.singleImageItem} src={profileData?.image?.links?.preview} />
                            )}
                        </div>
                    </div>
                    {showMenuUser && (
                        <div className={classNames(css.modalLangListWrap, css.modalUserListWrap)}>
                            <div className={css.modalLangListDesktop}>
                                <div
                                    className={classNames(css.modalLangListItemDesktop, css.modalLangListItemFirst)}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        navigateV2('/office');
                                    }}
                                    onTouchEnd={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        navigateV2('/office');
                                    }}
                                >
                                    <p className={css.menuLangSwitcherInfoDesktop}>
                                        <T textName='menuLangSwitcherInfoDesktop' defaultStr='Личный кабинет' page='/' />
                                    </p>
                                </div>
                                <div
                                    className={classNames(css.modalLangListItemDesktop, css.modalLangListItemFirst)}
                                    onClick={async () => logout()}
                                >
                                    <p
                                        className={classNames(
                                            css.menuLangSwitcherInfoDesktop,
                                            css.menuLangSwitcherInfoDesktopLog
                                        )}
                                    >
                                        <T textName='logoutFromAccountTitle' defaultStr='Выйти из аккаунта' page='all' />
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </>
        ) : (
            <>
                <div onClick={() => setState('showRegWindow', { type: 'login' })} className={css.headBtn}>
                    {svgSprite('user-gt')}
                </div>
            </>
        );
    };

    const router = useRouter();

    const isNewsPage = useMemo(() => {
        const newsRoutes = ['/[lang]/news', '/[lang]/news/[id]', '/[lang]/news/category/[id]'];
        return newsRoutes.includes(router.pathname);
    }, [router.pathname]);

    const isRegisterPage = useMemo(() => {
        const newsRoutes = ['/[lang]/auth/[...type]'];
        return newsRoutes.includes(router.pathname);
    }, [router.pathname]);

    return (
        <>
            <div
                className={classNames(css.langSwitcherRight, hasDataZooming ? css.langSwitcherRightZoom : '', {
                    [css.langSwitcherRightOpened]: isInputOpened
                })}
            >
                {windowDimensions > 767 && <RegionAndCurrencySwitcher mode='left' />}
                {isStorePage ? (
                    <div className={classNames(css.headBtn, css.headBtnSearch, { [css.headBtnSearcOpened]: isInputOpened })}>
                        <StoreSearch
                            afterClosedFunc={() => setIsInputOpened(false)}
                            afterOpenedFunc={() => setIsInputOpened(true)}
                        />
                    </div>
                ) : null}
                {isNewsPage ? (
                    <div className={classNames(css.headBtn, css.headBtnSearch)}>
                        <NewsSearch />
                    </div>
                ) : null}
                {isInputOpened ? null : (
                    <>
                        <Skeleton
                            wait={Boolean(loaded)}
                            wrapperStyles={{
                                width: '5rem'
                            }}
                            elements={[{ type: 'circle', gap: 0, diameter: 3.5 }]}
                            Component={HeaderProfile}
                        />
                        {isStorePage && !isRegisterPage ? (
                            <div
                                onClick={() => setCart(!cart)}
                                className={classNames(css.headBtn, css.headBtnCart, { [css.noBorder]: isInputOpened })}
                            >
                                <Cartbuttons openCart={openCart} setOpenCart={setOpenCart} />
                            </div>
                        ) : null}
                    </>
                )}
            </div>
        </>
    );
}
